import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Necesito equipo especial?',
  answer: 'No, solo una superficie firme y almohadas que ya tienes en casa.'
}, {
  question: '¿Tengo acceso inmediato?',
  answer: 'Sí, es un producto digital. Lo recibes en tu email segundos después de la compra.'
}, {
  question: '¿Es seguro si tengo una hernia discal?',
  answer: 'Sí, el protocolo está diseñado específicamente para aliviar la presión causada por hernias y protusiones.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-cream py-16 md:py-24 px-4" data-id="element-31">
      <div className="max-w-3xl mx-auto" data-id="element-32">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-33">
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-charcoal" data-id="element-34">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-35">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-36">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full text-left px-6 py-5 flex items-center justify-between focus:outline-none focus:ring-2 focus:ring-orange/50" aria-expanded={openIndex === index} data-id="element-37">
                <span className="font-heading font-bold text-lg text-charcoal pr-4" data-id="element-38">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-warm-gray transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180 text-orange' : ''}`} data-id="element-39" />
              </button>

              <AnimatePresence data-id="element-40">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-41">
                    <div className="px-6 pb-5 pt-1 border-t border-gray-50" data-id="element-42">
                      <p className="font-body text-warm-gray leading-relaxed" data-id="element-43">
                        {faq.answer}
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}